import styled from "styled-components";

export const Container = styled.div`
  margin-top: 26.4px;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 5px;

  .next-appointment-panel__details-button {
    width: 100%;
    height: 60px;
    margin-top: 10px;

    border-radius: 30px;
    text-align: center;
    vertical-align: middle;
    border: 0;
    font-size: 1.2rem;
    line-height: 60px;
    color: #fff;
    background-color: var(--blue2f);

    transition: all 0.5s ease-in-out;
    cursor: pointer;

    &:hover {
      filter: brightness(1.1);
    }
  }

  .next-appointment-panel__title {
    color: #fff;
    font-size: 20px;
  }

  .next-appointment-panel__time {
    font-weight: bold;
  }
`;
